import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layouts/application-layout/application-layout')
        .then(m => m.ApplicationLayout),
    children: [
      {
        path: '',
        redirectTo: 'step1',
        pathMatch: 'full'
      },
      {
        path: 'step1',
        loadComponent: () =>
          import('./features/application/pages/step1-page/step1-page')
            .then(m => m.Step1Page)
      },
      {
        path: 'step1/check-email',
        loadComponent: () =>
          import('./features/application/pages/check-email-page/check-email-page')
            .then(m => m.CheckEmailPage)
      },
      {
        path: 'step2',
        loadComponent: () =>
          import('./features/application/pages/step2-page/step2-page')
            .then(m => m.Step2Page)
      },
      {
        path: 'step3',
        loadComponent: () =>
          import('./features/application/pages/step3-page/step3-page')
            .then(m => m.Step3Page)
      },
      // eKYC is currently handed off to the external eKYC app (${ekycAppUrl}/longterm_esim/welcome);
      // these in-app routes/pages are unused for now but kept for a future in-flow eKYC callback.
      // {
      //   path: 'ekyc/start',
      //   loadComponent: () =>
      //     import('./features/ekyc/pages/start-page/start-page')
      //       .then(m => m.StartPage)
      // },
      // {
      //   path: 'ekyc/complete',
      //   loadComponent: () =>
      //     import('./features/ekyc/pages/complete-page/complete-page')
      //       .then(m => m.CompletePage)
      // },
      // {
      //   path: 'ekyc/error',
      //   loadComponent: () =>
      //     import('./features/ekyc/pages/error-page/error-page')
      //       .then(m => m.ErrorPage)
      // },
      {
        path: 'event/step1',
        loadComponent: () =>
          import('./features/application/pages/event-step1-page/event-step1-page')
            .then(m => m.EventStep1Page)
      },
      {
        path: 'event/step2',
        loadComponent: () =>
          import('./features/application/pages/event-step2-page/event-step2-page')
            .then(m => m.EventStep2Page)
      },
      {
        path: 'completed',
        loadComponent: () =>
          import('./features/application/pages/complete-page/complete-page')
            .then(m => m.ComplePage)
      },
    ]
  },
  // {
  //   path: 'upload-sample',
  //   loadComponent: () =>
  //     import('./features/application/pages/upload-sample-page/upload-sample-page')
  //       .then(m => m.UploadSamplePage)
  // },
  {
    // ヘッダー不要のため ApplicationLayout の外に配置
    path: 'completed',
    loadComponent: () =>
      import('./features/application/pages/complete-page/complete-page')
        .then(m => m.ComplePage)
  },
  {
    // ヘッダー不要のため ApplicationLayout の外に配置
    path: 'consent-items',
    loadComponent: () =>
      import('./features/parental-consent/consent-items/consent-items')
        .then(m => m.ConsentItems)
  },
  {
    // ヘッダー不要のため ApplicationLayout の外に配置
    path: 'filtering-service',
    loadComponent: () =>
      import('./features/parental-consent/filtering-service/filtering-service')
        .then(m => m.FilteringService)
  },
];
